import styles from "./index.css";
import logo from "./logo.png";
import classNames from "classnames";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";
import LoyaltyOptInModalButtons from "./LoyaltyOptInModalButtons";
import shouldShowModal from "./shouldShowModal";
import redirect from "./redirect";
import BottomLinks from "./BottomLinks";
import NoisyText from "./NoisyText";
import ProductImages from "./ProductImages";
import useOverflowControl from "./useOverflowControl";

const LoyaltyOptInModal = ({
  loyaltyBenefitType,
  enableComplianceVariant,
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  loyaltyNewInExperimentEnabled,
  loyaltyOptIn,
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject,
  storeCode,
  formatTranslation
}) => {
  const showModal = shouldShowModal({
    loyaltyBenefitType,
    loyaltyIsEnabled,
    loyaltyIsOptedIn,
    loyaltyNewInExperimentEnabled
  });

  useOverflowControl(showModal);

  if (!showModal) {
    return null;
  }

  return (
    <div className={styles.loyaltyOptInModal}>
      <div className={styles.container}>
        <button
          className={styles.closeButton}
          onClick={() => {
            analyticsLoyaltyOptInReject();
            redirect();
          }}
          aria-label={formatTranslation("accessibility_label_close")}
        />
        <img
          alt={formatTranslation("quick_join_overlay_a11y_logo")}
          src={logo}
          className={styles.logo}
        />
        <div>
          {!enableComplianceVariant && <ProductImages />}
          <NoisyText enableComplianceVariant={enableComplianceVariant} />
        </div>
        {!enableComplianceVariant && (
          <div className={classNames("leavesden1", styles.copy)}>
            {formatTranslation("quick_join_overlay_body_web")}
          </div>
        )}
        <LoyaltyOptInModalButtons
          enableComplianceVariant={enableComplianceVariant}
          storeCode={storeCode}
          loyaltyOptIn={() => {
            analyticsLoyaltyOptInClick();

            return loyaltyOptIn();
          }}
          loyaltyReject={() => {
            analyticsLoyaltyOptInReject();
            redirect();
          }}
        />
        <BottomLinks enableComplianceVariant={enableComplianceVariant} />
      </div>
    </div>
  );
};

LoyaltyOptInModal.propTypes = {
  loyaltyBenefitType: PropTypes.string,
  enableComplianceVariant: PropTypes.bool,
  loyaltyIsEnabled: PropTypes.bool,
  loyaltyIsOptedIn: PropTypes.bool,
  loyaltyNewInExperimentEnabled: PropTypes.bool,
  loyaltyOptIn: PropTypes.func.isRequired,
  analyticsLoyaltyOptInClick: PropTypes.func.isRequired,
  analyticsLoyaltyOptInReject: PropTypes.func.isRequired,
  storeCode: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(LoyaltyOptInModal);
